import { useStores, type ActionCard } from '@littlebird/sdk';
import { useEffect } from 'react';

type SourceChatFields = Pick<
  ActionCard,
  'origin' | 'chatId' | 'sourceMessagingChannelType'
> &
  Partial<Pick<ActionCard, 'sourceMeetingId'>>;

export const sourceChatIdOf = ({
  origin,
  chatId,
  sourceMessagingChannelType,
  sourceMeetingId,
}: SourceChatFields) =>
  origin === 'routine' || sourceMessagingChannelType || sourceMeetingId
    ? null
    : chatId;

export const useSourceChats = (cards: readonly SourceChatFields[]) => {
  const { threads } = useStores();

  const chatIdsKey = [
    ...new Set(cards.flatMap((card) => sourceChatIdOf(card) || [])),
  ].join('\n');

  useEffect(() => {
    if (!chatIdsKey) return;

    for (const chatId of chatIdsKey.split('\n')) {
      void threads.ensureLoaded(chatId).catch(() => undefined);
    }
  }, [chatIdsKey, threads]);
};
